import { Zap } from 'lucide-react';

const WORDS = [
  'Bitcoin',
  'Lightning',
  'Nostr',
  'Ecash',
  'Zaps',
  'Freedom Tech',
  'Open Source',
  'Self-Custody',
  'Nairobi',
];

export function Marquee() {
  return (
    <div className="overflow-hidden border-y border-primary/20 bg-primary py-3" aria-hidden>
      <div className="flex w-max animate-marquee gap-0 motion-reduce:animate-none">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center">
            {WORDS.map((word) => (
              <span
                key={`${copy}-${word}`}
                className="inline-flex items-center gap-6 pr-6 text-sm font-bold uppercase tracking-[0.25em] text-primary-foreground"
              >
                {word}
                <Zap className="size-4" fill="currentColor" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
